var app = angular.module('app', [
		"ngSanitize",
        'ui.router',
        'ngAnimate',
        'ncy-angular-breadcrumb',
        'ngMaterial',
        'ngMessages',
        'ngFileUpload',
        'ui.sortable',
        'chart.js'
]);
